// ============================================================
// withTimeout - reject a promise after `ms` with a friendly
// message. The underlying operation is NOT cancelled (Firestore
// promises aren't abortable) - this only bounds how long the UI
// waits. Built for the session screen, where an unreachable
// backend makes the SDK retry indefinitely and a join/create
// otherwise hangs with zero feedback.
// ============================================================
export function withTimeout<T>(promise: Promise<T>, ms: number, message: string): Promise<T> {
  let timer: ReturnType<typeof setTimeout>;
  return Promise.race([
    promise,
    new Promise<never>((_resolve, reject) => {
      timer = setTimeout(() => reject(new Error(message)), ms);
    }),
  ]).finally(() => clearTimeout(timer)) as Promise<T>;
}
